export default {
  filters: {},
  timeFrames: [],
  events: [],
  commandLog: []
};